export const NAME = "page-registration";

export const REGISTER_USER_FORM = `${NAME}/REGISTER_USER_FORM`;
